module.exports = __webpack_public_path__ + "static/img/71.a99f0f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Teams/71.png
// module id = WZ0B
// module chunks = 1